export const optionsBankAccNewTimeLine = [
	{
		name: 'Rascunho',
		value: 'Draft'
	},
	{
		name: 'Aprovação Abertura de Conta Bancaria',
		value: 'BankAccountApprove'
	},
	{
		name: 'Assinatura',
		value: 'Signature'
	},
	{
		name: 'Abertura de conta',
		value: 'BankAccountOpen'
	},
	{
		name: 'Encerrado',
		value: 'Finished'
	},
	{
		name: 'Cancelada',
		value: 'Cancel'
	},
	{
		name: 'Reprovado',
		value: 'Disapproved',
	},
	{
		name: 'Revisão',
		value: 'Revision'
	},
];